<template>
    <div>
      <div ref="header">
        <playerHeader v-bind:player="player"/>
      </div>
      <nav-list :routers="routers">
          <keep-alive>
            <router-view ref="routerView"/>
          </keep-alive>
        </nav-list>
    </div>
</template>

<script>
import NavList from '@/components/NavList.vue'
import playerHeader from './components/playerHeader.vue'
import { scrollHeaderMinxin } from '@/views'

export default {
  name: 'player',
  props: {
    playerId: {
      type: String,
      required: true
    }
  },
  mixins: [scrollHeaderMinxin],
  data: function () {
    return {
      player: {}
    }
  },
  computed: {
    birthdayStr: function () {
      var birthdayDate = new Date(this.player.birthday * 1000)
      return birthdayDate.toISOString().split('T')[0]
    },
    routers: function () {
      return [
        [this.$t('playerIndex.playerInfo'), 'football-player-info', { ...this.$router.params, 'playerForRoute': this.player }],
        [this.$t('playerIndex.playerStats'), 'football-player-stats', this.$router.params]
      ]
    }
  },
  components: {
    NavList,
    playerHeader
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      // ${this.playerId}
      this.$dataBaseClient.get(`f_player/playerInfo?playerId=${this.playerId}`)
        .then((response) => {
          this.player = response
          this.$refs.routerView.player = this.player
          this.pageTitle = this.player.playerName
        })
        .catch((error) => {
          console.log(error)
        })
        .then(function () {
          // always executed
        })
    }
  }
}
</script>

<style lang="sass" scoped>
@import '~@/styles'
</style>
